import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { InfoRounded } from "@material-ui/icons";
import {
  baseColor2,
  inputDefaultColor,
  inputDisabledBgColor,
  lightBaseColor1,
  errorColor,
  buttonDisabledColor,
} from "../styles/color";

const TextInput = (props) => {
  const inputStyles = css`
    ${props.fullWidth && "width: 100%;"}
    box-sizing: border-box;
    background-color: ${inputDefaultColor};
    color: ${baseColor2};
    font-family: inherit;
    font-size: 1rem;
    line-height: ${props.type === "textarea" ? "1.6" : "unset"};
    outline: none;
    border: 1px solid ${props.errorMsg ? errorColor : inputDefaultColor};
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;

    &::placeholder {
      color: ${lightBaseColor1};
    }

    &:hover {
      border-color: ${lightBaseColor1};
    }

    &:focus {
      border-color: ${props.errorMsg ? errorColor : baseColor2};
    }

    &:disabled {
      background-color: ${inputDisabledBgColor};
      color: ${buttonDisabledColor};
      cursor: not-allowed;

      &::placeholder {
        color: ${buttonDisabledColor};
      }

      &:hover {
        border-color: ${inputDisabledBgColor};
      }
    }
  `;

  const errorStyles = css`
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: 0.5rem;
    margin-top: 0.75rem;

    svg {
      color: ${errorColor};
      height: 20px;
      width: 20px;
    }

    span {
      font-size: 0.875rem;
      line-height: 1.6;
    }
  `;

  const infoStyles = css`
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: 0.5rem;
    margin-top: 0.75rem;

    svg {
      color: ${baseColor2};
      height: 20px;
      width: 20px;
    }

    span {
      font-size: 0.875rem;
      line-height: 1.6;
    }
  `;

  return (
    <>
      {props.type === "textarea" && (
        <textarea
          css={[inputStyles, props.styles]}
          name={props.name}
          placeholder={props.placeholder}
          disabled={props.disabled}
          value={props.value}
          onChange={props.onChange}
        >
          text
        </textarea>
      )}
      {(props.type === "text" || props.type === "email") && (
        <input
          css={[inputStyles, props.styles]}
          type={props.type}
          name={props.name}
          placeholder={props.placeholder}
          disabled={props.disabled}
          value={props.value}
          onChange={props.onChange}
        />
      )}
      {props.type === "number" && (
        <input
          css={[inputStyles, props.styles]}
          type="text"
          name={props.name}
          placeholder={props.placeholder}
          disabled={props.disabled}
          value={props.value}
          onChange={(e) => {
            // Restrict entry to numbers only
            if (/^\d*$/.test(e.target.value)) {
              props.onChange(e);
            }
          }}
        />
      )}
      {props.errorMsg ? (
        <div css={[errorStyles, props.styles]}>
          <InfoRounded />
          <span>{props.errorMsg}</span>
        </div>
      ) : null}
      {props.infoMsg ? (
        <div css={[infoStyles, props.styles]}>
          <InfoRounded />
          <span>{props.infoMsg}</span>
        </div>
      ) : null}
    </>
  );
};

TextInput.defaultProps = {
  type: "text",
  name: "unknown",
  placeholder: "",
  disabled: false,
  fullWidth: false,
  value: "",
  errorMsg: undefined,
  infoMsg: undefined,
  onChange: undefined,
};

TextInput.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorMsg: PropTypes.string,
  infoMsg: PropTypes.string,
  onChange: PropTypes.func,
  styles: PropTypes.object,
};

export default TextInput;
